import { EnvironmentId } from "../enums/environment-id.enum";
import { FirebaseConfig } from "../models/firebase-config.model";

export const firebaseConfigProduction: FirebaseConfig = {
  apiKey: "AIzaSyCJAIf04fpAtAKObNNqoijL6HTrQCwUenU",
  authDomain: "prism-985c8.firebaseapp.com",
  projectId: "prism-985c8",
  storageBucket: "prism-985c8.appspot.com",
  messagingSenderId: "671938550201",
  appId: "1:671938550201:web:cc29b69c380facdfaf3e68",
  measurementId: "G-HVPQYKW6TY"
};

export const firebaseConfigStaging: FirebaseConfig = {
  apiKey: "AIzaSyB3BjQk-3CG0Ph-VaMfZAWSst04d_2NNZ8",
  authDomain: "prism-staging-d549f.firebaseapp.com",
  projectId: "prism-staging-d549f",
  storageBucket: "prism-staging-d549f.appspot.com",
  messagingSenderId: "257889288841",
  appId: "1:257889288841:web:1d85827d3eb474830fbc58",
  measurementId: "G-ENMLMN9VCJ"
};

export const firebaseConfigTesting: FirebaseConfig = {
  apiKey: "AIzaSyC2MC5jtHelLLDePznY-Jcgf-BzFjXvSd4",
  authDomain: "prism-testing-13314.firebaseapp.com",
  projectId: "prism-testing-13314",
  storageBucket: "prism-testing-13314.firebasestorage.app",
  messagingSenderId: "1052088072921",
  appId: "1:1052088072921:web:5e77872b67a3fda1545cc8",
  measurementId: "G-T0455Q5Y7Z"
};

export const firebaseConfigDict: Partial<Record<EnvironmentId, FirebaseConfig>> = {
  [EnvironmentId.Staging]: firebaseConfigStaging,
  [EnvironmentId.Testing]: firebaseConfigTesting,
  [EnvironmentId.Production]: firebaseConfigProduction,
}